
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import ReservationModal from '../components/ReservationModal';
import ReservationSelectionModal from '../components/ReservationSelectionModal'; // [Novo]

export default function CheckIn() {
    const [sectors, setSectors] = useState([]);
    const [beds, setBeds] = useState([]);
    const [formData, setFormData] = useState({
        sectorId: '',
        bedId: '',
        patientName: '',
        gender: '',
        admissionType: 'Eletiva',
        precautions: 'Nenhuma',
        condition: 'Deâmbula',
        reservationId: null,
        housekeeperRequired: true // [Novo] Default: Acionar governanta
    });
    const [loading, setLoading] = useState(false);
    const [showReservationModal, setShowReservationModal] = useState(false);
    const [showSelectionModal, setShowSelectionModal] = useState(false); // [Novo]
    const [specificBedIdToSelect, setSpecificBedIdToSelect] = useState(null); // [Novo] Para leito sugerido de reserva
    const navigate = useNavigate();
    const location = useLocation(); // [Novo] Hook para receber dados
    const { user } = useAuth();

    // Permissão para abrir modal de reserva (Criação)
    const canAccessNIR = user?.role_name === 'Administrador' || user?.permissions?.includes('access_nir');

    // Função auxiliar para preencher dados (Reuso)
    const fillFromReservation = (r) => {
        console.log('Preenchendo com reserva:', r);
        setFormData(prev => ({
            ...prev,
            sectorId: r.sector_id || '',
            patientName: r.patient_name || '', // Se não tiver nome, usa placeholder
            gender: r.patient_gender || '',
            condition: r.patient_condition || 'Deâmbula',
            precautions: r.patient_precautions || 'Nenhuma',
            admissionType: r.origin && r.origin.includes('Transferência') ? 'Transferência' : (r.origin === 'Cirurgia Eletiva' ? 'Eletiva' : 'Urgência'), // Inferência melhorada
            reservationId: r.id
        }));
        // Armazena o ID do leito sugerido para ser usado após o carregamento dos leitos do setor
        setSpecificBedIdToSelect(r.specific_bed_id || null);
    };

    // [Refatorado] Preencher dados se vier de uma reserva (Via Navegação)
    useEffect(() => {
        if (location.state?.reservation) {
            fillFromReservation(location.state.reservation);
        }
    }, [location.state]);

    useEffect(() => {
        // Carregar setores ao iniciar
        const fetchSectors = async () => {
            try {
                const response = await api.get('/sectors');
                setSectors(response.data);
            } catch (error) {
                console.error('Erro ao carregar setores:', error);
            }
        };
        fetchSectors();
    }, []);

    // Carregar leitos quando setor muda
    useEffect(() => {
        if (formData.sectorId) {
            const fetchBeds = async () => {
                try {
                    const response = await api.get('/beds');
                    console.log('Todos os leitos:', response.data);

                    // Filtrar apenas do setor selecionado E com status disponível
                    // Status 1 = Disponível, 6 = Reservado para Internação, 7 = Aguardando Paciente
                    const availableStatuses = [1, 6, 7];
                    const sectorBeds = response.data.filter(
                        bed => bed.sectorId && bed.sectorId == formData.sectorId && availableStatuses.includes(bed.statusId)
                    );

                    console.log('Leitos do setor ' + formData.sectorId + ':', sectorBeds);

                    setBeds(sectorBeds);

                    // Lógica para selecionar leito específico automaticamente
                    if (specificBedIdToSelect) {
                        const specificBed = sectorBeds.find(b => b.id == specificBedIdToSelect);
                        if (specificBed) {
                            setFormData(prev => ({ ...prev, bedId: specificBed.id }));
                        }
                        setSpecificBedIdToSelect(null); // Limpa após tentar selecionar
                    }

                } catch (error) {
                    console.error('Erro ao carregar leitos:', error);
                }
            };
            fetchBeds();
        } else {
            setBeds([]);
        }
    }, [formData.sectorId, specificBedIdToSelect]); // Dependência do sectorId e specificBedIdToSelect

    // [Novo] Função para lidar com a seleção de uma reserva no modal de seleção
    const handleSelectReservation = (reservation) => {
        fillFromReservation(reservation);
        setShowSelectionModal(false); // Fechar o modal após a seleção
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await api.post('/service-alerts/checkin', {
                ...formData,
                bedId: parseInt(formData.bedId)
            });

            // Feedback visual das precauções
            let alertMsg = 'Check-in realizado com sucesso!';
            if (formData.precautions !== 'Nenhuma') {
                alertMsg += `\n\n⚠️ PRECAUÇÃO DEFINIDA: ${formData.precautions} \n`;
                if (formData.precautions.includes('Contato')) alertMsg += '- Use Luvas e Avental';
                if (formData.precautions.includes('Gotículas')) alertMsg += '- Use Máscara Cirúrgica';
                if (formData.precautions.includes('Aerossóis')) alertMsg += '- Use Máscara N95/PFF2';
            }

            alert(alertMsg);
            navigate('/');
        } catch (error) {
            console.error('Erro no check-in:', error);
            alert('Erro ao realizar check-in: ' + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h3 className="mb-0"><i className="bi bi-person-plus-fill me-2"></i>Check-in de Admissão</h3>
                    <div className="d-flex gap-2"> {/* [Novo] Container para os botões */}
                        {/* Botão para Recepcionista buscar reserva */}
                        <button
                            className="btn btn-light text-primary fw-bold"
                            onClick={() => setShowSelectionModal(true)}
                        >
                            <i className="bi bi-search me-2"></i>
                            Buscar Reservas (NIR)
                        </button>

                        {canAccessNIR && (
                            <button
                                className="btn btn-warning text-dark fw-bold"
                                onClick={() => setShowReservationModal(true)}
                            >
                                <i className="bi bi-calendar-plus me-2"></i>
                                Criar Reserva
                            </button>
                        )}
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>

                        {/* Linha 1: Setor e Leito */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">Unidade / Setor</label>
                                <select
                                    className="form-select"
                                    value={formData.sectorId}
                                    onChange={e => setFormData({ ...formData, sectorId: e.target.value, bedId: '' })}
                                    required
                                >
                                    <option value="">Selecione o Setor</option>
                                    {sectors.map(sector => (
                                        <option key={sector.id} value={sector.id}>{sector.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Leito Disponível</label>
                                <select
                                    className="form-select"
                                    value={formData.bedId}
                                    onChange={e => setFormData({ ...formData, bedId: e.target.value })}
                                    required
                                    disabled={!formData.sectorId}
                                >
                                    <option value="">Selecione o Leito</option>
                                    {beds.length === 0 && formData.sectorId && (
                                        <option disabled>Nenhum leito disponível neste setor</option>
                                    )}
                                    {beds.map(bed => {
                                        // Mapear status IDs para labels
                                        const statusMap = {
                                            1: 'Disponível',
                                            6: 'Reservado',
                                            7: 'Aguardando Paciente'
                                        };
                                        const statusLabel = statusMap[bed.statusId] || 'Status Desconhecido';
                                        return (
                                            <option key={bed.id} value={bed.id}>
                                                {bed.number} - {statusLabel}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>

                        {/* Linha 2: Nome do Paciente e Sexo */}
                        <div className="row mb-3">
                            <div className="col-md-8">
                                <label className="form-label">Nome do Paciente</label>
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    value={formData.patientName}
                                    onChange={e => setFormData({ ...formData, patientName: e.target.value })}
                                    placeholder="Nome completo do paciente"
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Sexo</label>
                                <select
                                    className="form-select form-select-lg"
                                    value={formData.gender}
                                    onChange={e => setFormData({ ...formData, gender: e.target.value })}
                                    required
                                >
                                    <option value="">Selecione</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Feminino">Feminino</option>
                                </select>
                            </div>
                        </div>

                        {/* Linha 3: Detalhes da Admissão */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <label className="form-label">Tipo de Internação</label>
                                <select
                                    className="form-select"
                                    value={formData.admissionType}
                                    onChange={e => setFormData({ ...formData, admissionType: e.target.value })}
                                >
                                    <option value="Eletiva">Eletiva</option>
                                    <option value="Urgência">Urgência</option>
                                    <option value="Emergência">Emergência</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label text-danger fw-bold">Precaução</label>
                                <select
                                    className="form-select border-danger"
                                    value={formData.precautions}
                                    onChange={e => setFormData({ ...formData, precautions: e.target.value })}
                                >
                                    <option value="Nenhuma">Nenhuma</option>
                                    <option value="Contato">Contato (Luvas/Avental)</option>
                                    <option value="Gotículas">Gotículas (Máscara Cirúrgica)</option>
                                    <option value="Aerossóis">Aerossóis (N95/PFF2)</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Condição</label>
                                <select
                                    className="form-select"
                                    value={formData.condition}
                                    onChange={e => setFormData({ ...formData, condition: e.target.value })}
                                >
                                    <option value="Deâmbula">Deâmbula</option>
                                    <option value="Acamado">Acamado</option>
                                </select>
                            </div>
                        </div>

                        {/* Alerta Visual de EPIs */}
                        {formData.precautions !== 'Nenhuma' && (
                            <div className="alert alert-warning animate__animated animate__fadeIn">
                                <h5><i className="bi bi-exclamation-triangle-fill me-2"></i>EPIs Necessários:</h5>
                                <ul className="mb-0">
                                    {formData.precautions.includes('Contato') && <li>Luvas de procedimento e Avental descartável</li>}
                                    {formData.precautions.includes('Gotículas') && <li>Máscara Cirúrgica (Paciente e Equipe)</li>}
                                    {formData.precautions.includes('Aerossóis') && <li>Máscara N95/PFF2 (Equipe)</li>}
                                </ul>
                            </div>
                        )}

                        {/* [Novo] Toggle para Acionar Governanta */}
                        <div className="card bg-light border-0 mb-3">
                            <div className="card-body py-2">
                                <div className="form-check form-switch d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input fs-4"
                                        type="checkbox"
                                        id="housekeeperToggle"
                                        checked={formData.housekeeperRequired}
                                        onChange={e => setFormData({ ...formData, housekeeperRequired: e.target.checked })}
                                    />
                                    <label className="form-check-label fw-bold text-dark pt-1" htmlFor="housekeeperToggle">
                                        Solicitar Acompanhamento da Governanta
                                    </label>
                                </div>
                                <small className="text-muted ms-5 d-block" style={{ marginTop: '-5px' }}>
                                    Desmarque apenas para transferências internas ou quando o acompanhamento não for necessário.
                                </small>
                            </div>
                        </div>

                        <div className="d-grid gap-2 mt-4">
                            <button
                                type="submit"
                                className="btn btn-success btn-lg"
                                disabled={loading}
                            >
                                {loading ? 'Processando...' : 'Confirmar Check-in e Notificar Governanta'}
                            </button>
                        </div>

                    </form>
                </div>
            </div>
            <ReservationModal
                show={showReservationModal}
                onClose={() => setShowReservationModal(false)}
            />
            <ReservationSelectionModal
                show={showSelectionModal}
                onClose={() => setShowSelectionModal(false)}
                onSelect={fillFromReservation}
            />
        </div>
    );
}
